import client from "./api.client";
import {
  ApiResponse,
  ChangePassPayload,
  CommandResponse,
  DeleteUserPayload,
  GetAddressesResponse,
  GetHistoPayload,
  GetHistoResponse,
  GetInfosResponse,
  GetPoolsDetailResponse,
  ListPoolsResponse,
  RenameIOPayload,
  RenameIOResponse,
  SetAutoOff,
  SetInfosPayload,
  SetOutPayload,
  SetParamPayload,
  SetPlagesPayload,
  SetSeuilsPayload,
} from "@/models/api.models";
import sha1 from "sha1";
import { throwOnCommandError } from "@/shared/utils/commands";
import { getVersionId } from "@/shared/utils/misc/version";

export default class ApiService {
  async login(login: string, password: string): Promise<string> {
    return client
      .post(
        `/GetJWT.php`,
        {
          login,
          password: sha1(password),
          version: getVersionId(),
        },
        {
          withCredentials: true,
        }
      )
      .then((resp) => resp.headers.authorization.split(" ")[1]);
  }

  async listPools(
    max?: number,
    start?: number,
    search?: string,
    filter?: string,
    sort?: "p" | "P" | "a" | "A"
  ) {
    return client
      .post<ListPoolsResponse>("/GetIndex.php", {
        max,
        start,
        S: search,
        filter,
        sort,
      })
      .then((resp) => resp.data);
  }

  async getAddresses() {
    return client
      .post<GetAddressesResponse>("/GetAddresses.php", {})
      .then((resp) => resp.data);
  }

  async getPoolDetails(poolId: string) {
    return client
      .post<GetPoolsDetailResponse>("/GetPoolDetails.php", {
        poolID: poolId,
        lang: "fr",
      })
      .then((resp) => resp.data.response[0]);
  }

  async getInfos() {
    return client
      .get<GetInfosResponse>("/GetInfos.php")
      .then((resp) => resp.data.response.MyInfos);
  }

  async setInfos(payload: SetInfosPayload) {
    return client.post("/SetInfos.php", payload);
  }

  async changePass(payload: ChangePassPayload) {
    return client.post("/ChangePass.php", payload);
  }

  async setSeuils(payload: SetSeuilsPayload) {
    return client
      .post<CommandResponse>("/SetSeuils.php", payload)
      .then((resp) => resp.data.response[0].cmdID);
  }

  async setParam(payload: SetParamPayload) {
    return client
      .post<CommandResponse>("/SetParam.php", payload)
      .then((resp) => resp.data.response[0].cmdID);
  }

  async setOut(payload: SetOutPayload) {
    return client
      .post<CommandResponse>("/SetOut.php", payload)
      .then((resp) => resp.data.response[0].cmdID);
  }

  async setAutoOff(payload: SetAutoOff) {
    return client
      .post<CommandResponse>("/SetAutoOff.php", payload)
      .then((resp) => resp.data.response[0].cmdID);
  }

  async setPlages(payload: SetPlagesPayload) {
    return client
      .post<CommandResponse>("/SetPlages.php", payload)
      .then((resp) => resp.data.response[0].cmdID);
  }

  async waitCommand(cmdID: number) {
    return client.post("/WaitCommand.php", { cmdID }).then((resp) => {
      throwOnCommandError(resp.data.response.status);
      return resp;
    });
  }

  async getHisto(payload: GetHistoPayload) {
    return client
      .post<GetHistoResponse>("/GetHisto.php", payload)
      .then((resp) => resp.data.response);
  }

  async renameIO(payload: RenameIOPayload) {
    return client
      .post<RenameIOResponse>("/RenameIO.php", payload)
      .then((resp) => resp.data.response);
  }

  async deleteUser(payload: DeleteUserPayload) {
    return client
      .post<ApiResponse<unknown>>("/DeleteUser.php", {
        ...payload,
        pass: sha1(payload.pass),
      })
      .then((resp) => resp.data.response);
  }
}
